const PermissionLevels = {
    admin: "admin",
    default: "default",
};

export { PermissionLevels };